import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { IconButton, InputAdornment, Stack, Typography, Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import OTPPage from '../../../components/register_otp/otpPage';
import FormProvider, { RHFTextField } from '../../../components/hook-form';
import Iconify from '../../../components/iconify';
import Notification from '../../../components/Notification/Notification';
import { useDispatch, useSelector } from '../../../redux/store';
import {
  forgetPasswordOTP,
  forgetPasswordChangePassword,
  unsubscribeOTPAction,
} from '../../../redux/slices/user';

// ----------------------------------------------------------------------

export default function AuthResetPasswordForm() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openResultDialog, setOpenResultDialog] = useState(false);
  const { forgetPasswordVerified, forgetPasswordAction } = useSelector((state) => state.user);

  const [open, setOpen] = useState(false);
  const [emailForOTP, setEmailForOTP] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [count, setCount] = useState(0);

  const [notification, setNotification] = useState({ open: false, msg: "", type: "success", });

  const ResetPasswordSchema = Yup.object().shape({
    email: Yup.string().required('Email is required').email('Email must be a valid email address'),
    password: Yup.string()
      .required('Password is required')
      .min(6, 'Password should be of minimum 6 characters length'),
  });

  const defaultValues = {
    email: '',
    password: '',
  };

  const methods = useForm({
    resolver: yupResolver(ResetPasswordSchema),
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    getValues,
    setError,
    formState: { isSubmitting, errors },
  } = methods;

  const onSubmit = async (data) => {
    try {
      dispatch(forgetPasswordOTP(0, 'FORGETPASSWORD', data.email));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (forgetPasswordAction) {
      if (typeof forgetPasswordAction === 'string') {
        reset();
        setError('afterSubmit', {
          message: forgetPasswordAction,
        });
      }
      if (typeof forgetPasswordAction === 'object') {
        setOpen(true);
        setEmailForOTP(getValues('email'));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forgetPasswordAction]);

  useEffect(() => {
    if (forgetPasswordVerified) {
      if (typeof forgetPasswordVerified === 'string') {
        setError('afterSubmit', {
          message: 'OTP Verify Failed',
        });
        dispatch(unsubscribeOTPAction());
      }
      if (typeof forgetPasswordVerified === 'object') {
        setOpenResultDialog(true);
        dispatch(unsubscribeOTPAction());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forgetPasswordVerified, dispatch, navigate]);

  const handleResultClose = () => {
    setOpenResultDialog(false);
    navigate('/', { state: { open: true, msg: "Password Updated Successfully", type: "success" } });
  };

  const CallOTP_Verification = (otp) => {
    try {
      dispatch(
        forgetPasswordChangePassword(methods.getValues().email, otp, methods.getValues().password)
      );
    } catch (error) {
      console.error(error);
    }
  };

  const handleResendOTP = () => {
    dispatch(forgetPasswordOTP(0, 'FORGETPASSWORD', emailForOTP));
  };

  return (
    <>
      <Dialog open={openResultDialog} onClose={handleResultClose}>
        <DialogTitle>
          <Stack direction="column" alignItems="center" justifyContent="center">
            <Iconify icon="line-md:check-all" width={80} color="green" />
            <Typography variant='body1' fontWeight={600}>Password Reset Successful</Typography>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            You had Successful Reset The Password!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleResultClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>}

        <RHFTextField name="email" hiddenLabel placeholder="Email address" />
        <RHFTextField
          name="password"
          label="New Password"
          sx={{ mt: 2.5 }}
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'carbon:view' : 'carbon:view-off'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={isSubmitting}
          sx={{ mt: 2.5 }}
        >
          Reset Password
        </LoadingButton>

        <OTPPage
          email={emailForOTP}
          CallOTP_Verification={CallOTP_Verification}
          onClose={() => setOpen(false)}
          open={open}
          ResendOTP={handleResendOTP}
          errorMsg={!!errors.afterSubmit && errors.afterSubmit.message}
          setError={setError}
        />
      </FormProvider></>
  );
}
